<template>
  <div class="shortlists-selection-inner">
    <h4>Shortlists</h4>

    <simplebar class="shortlists-list" data-simplebar-auto-hide="false">
      <div
        v-for="list in currentShortlists(search)"
        :key="list.id"
        class="shortlist-item"
        :class="{ active: selectedShortlist === list.id }"
        @click="selectShortlist(list.id)"
      >
        <span class="name">{{ list.name }}</span>
        <span v-if="list.companyId !== null" class="company">{{
          getCompanyNameByVismaId(list.companyId)
        }}</span>
        <span v-else class="company no-company">No company selected</span>
        <span class="updated">{{
          list.updated.toDate() | moment("YYYY-MM-DD - HH:mm")
        }}</span>
      </div>
    </simplebar>

    <div class="shortlist-search">
      <span class="material-icons">search</span>
      <input
        @input="debounceSearch"
        type="search"
        ref="shortlistSearch"
        placeholder="Search shortlist..."
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";

export default {
  name: "CompanyShortlistsSelector",
  data() {
    return {
      search: "",
      timeout: null,
    };
  },
  components: {
    simplebar,
  },
  methods: {
    debounceSearch: function () {
      if (this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.search = this.$refs.shortlistSearch.value;
      }, 500);
    },
    selectShortlist: function (listId) {
      this.$store.commit("companyShortlists/setSelectedShortlist", listId);
      this.$store.dispatch("companyShortlists/setupEditing");
    },
  },
  computed: {
    ...mapState({
      selectedShortlist: (state) => state.companyShortlists.selectedShortlist,
    }),
    ...mapGetters("settings", ["getCompanyNameByVismaId"]),
    ...mapGetters("companyShortlists", ["currentShortlists"]),
  },
};
</script>
